<div class="account-cell-container">
  <span class="bookmark">
    <sac-ng-bookmark [entityType]="AccountEntityType" [entityValue]="accountNumber"></sac-ng-bookmark>
  </span>
  <p> <a (click)="accountNumberLink()">{{ accountNumber }}</a></p>
</div>
